module.exports = __webpack_public_path__ + "img/logo-footer-3.438c1766.jpg";